import { Component, Input } from '@angular/core';
import { SliderConfig } from '@planone/bau365/data-access-screensize';
import { Exhibitor } from '@planone/bau365/util-fair-data';
import { stringifyFilter } from '@planone/shared/util-interfaces';

@Component({
  selector: 'bau365-exhibitor-section-exhibitor-references',
  templateUrl: './section-exhibitor-references.component.html',
  styleUrls: ['./section-exhibitor-references.component.scss'],
})
export class SectionExhibitorExhibitorReferencesComponent {
  @Input() exhibitor?: Exhibitor;
  @Input() parent: Exhibitor | null | undefined;
  @Input() coExhibitors: Exhibitor[] | null | undefined;
  @Input() size?: string;
  @Input() cardSliderConfig: SliderConfig | null | undefined;
  @Input() imageZoomed?: boolean;

  stringifyFilter = stringifyFilter;
}
